export const AmbikaVenderApi = 'https://www.erp.ambikadairyfarm.com/api'